<template>
  <div class="loading_con" v-show="confirm.show"></div>
</template>
<style>
.loading_con {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 10;
}
</style>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: mapState(['confirm']),
  methods: {
    ...mapActions(['hideConfirm'])
  },
  watch: {
    'confirm.show': function(val, oldVal) {
      if (val && !oldVal) {
        this.$snotify.confirm(this.confirm.msg, this.confirm.title, {
          timeout: 0,
          position: 'centerCenter',
          closeOnClick: false,
          buttons: [
            {
              text: '取消',
              action: toast => {
                this.hideConfirm()
                this.$snotify.remove(toast.id)
              }
            },
            {
              text: '确定',
              bold: true,
              action: toast => {
                this.hideConfirm()
                this.$snotify.remove(toast.id)
                this.confirm && this.confirm.ok && this.confirm.ok()
              }
            }
          ]
        })
      }
    }
  }
}
</script>
